import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "b-appointment-qualification__title qa-appointment-qualification-title" }
const _hoisted_2 = { class: "b-appointment-qualification__buttons" }
const _hoisted_3 = ["disabled", "aria-label", "aria-pressed"]
const _hoisted_4 = ["disabled", "aria-label", "aria-pressed"]
const _hoisted_5 = {
  key: 1,
  class: "b-appointment-qualification__error qa-appointment-qualification-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-appointment-qualification qa-appointment-qualification", _ctx.sectionModifier])
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('EVENT.PREVIEW.QUALIFICATION.TITLE')), 1),
    (_ctx.qualification !== null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["b-appointment-qualification__badge qa-appointment-qualification-badge", _ctx.isHonored ? "b-appointment-qualification__badge--honored" : "b-appointment-qualification__badge--not-honored"])
        }, _toDisplayString(_ctx.badgeText), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["b-appointment-qualification__button b-appointment-qualification__button--yes qa-appointment-qualification-yes", {
                "b-appointment-qualification__button--selected": _ctx.isHonored,
                "b-appointment-qualification__button--muted": _ctx.isNotHonored,
            }]),
        disabled: _ctx.isLoading,
        "aria-label": _ctx.$t("EVENT.PREVIEW.QUALIFICATION.ARIA.YES"),
        "aria-pressed": _ctx.isHonored ? "true" : "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.qualify(true)))
      }, [
        (_ctx.isLoading && _ctx.pendingValue === true)
          ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
              key: 0,
              isActive: true,
              size: 8,
              colors: _ctx.yesSpinnerColors
            }, null, 8, ["colors"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_FwIcon, {
                icon: "ok-circle",
                size: "16",
                color: _ctx.yesIconColor
              }, null, 8, ["color"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('EVENT.PREVIEW.QUALIFICATION.YES')), 1)
            ], 64))
      ], 10, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["b-appointment-qualification__button b-appointment-qualification__button--no qa-appointment-qualification-no", {
                "b-appointment-qualification__button--selected": _ctx.isNotHonored,
                "b-appointment-qualification__button--muted": _ctx.isHonored,
            }]),
        disabled: _ctx.isLoading,
        "aria-label": _ctx.$t("EVENT.PREVIEW.QUALIFICATION.ARIA.NO"),
        "aria-pressed": _ctx.isNotHonored ? "true" : "false",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.qualify(false)))
      }, [
        (_ctx.isLoading && _ctx.pendingValue === false)
          ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
              key: 0,
              isActive: true,
              size: 8,
              colors: _ctx.noSpinnerColors
            }, null, 8, ["colors"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_FwIcon, {
                icon: "close-circle",
                size: "16",
                color: _ctx.noIconColor
              }, null, 8, ["color"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('EVENT.PREVIEW.QUALIFICATION.NO')), 1)
            ], 64))
      ], 10, _hoisted_4)
    ]),
    (_ctx.isErrorShow)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('EVENT.PREVIEW.QUALIFICATION.ERROR')), 1))
      : _createCommentVNode("", true)
  ], 2))
}